import { render, staticRenderFns } from "./IngredientCreate.vue?vue&type=template&id=aea6a62e&"
import script from "./IngredientCreate.vue?vue&type=script&lang=js&"
export * from "./IngredientCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports